import { generateId } from '@feedyou/utils'

// This is slightly useful for testing
export const generateMissingId = () => generateId('lowercase', 10)
export const regenerateDuplicateId = () => generateId('lowercase', 10)
